<template>
  <!-- <v-autocomplete
    :clearable="clearable"
    v-model="brandValue"
    :items="$store.state.brands"
    :loading="isLoading"
    :search-input="searchBrand"
    item-text="name"
    item-value="id"
    outlined
    placeholder="Brand"
    dense
    :multiple="multiple"
    @input="handleInput"
  ></v-autocomplete> -->
  <v-file-input
    :rules="rules"
    @click:clear="$emit('input', null)"
    :loading="isLoading"
    @change="handleChange"
    :disabled="readOnly"
    :label="label"
    :accept="accept"
    v-model="fileValue"
    :clearable="clearable"
    :prepend-icon="prependIcon"
    show-size
  ></v-file-input>
</template>

<script>
import { FileService } from "@/services"
export default {
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "File upload"
    },
    prependIcon: {
      type: String,
      default: "mdi-file"
    },
    accept: {
      type: String,
      default: "*"
    },
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fileValue: null,
      fileData: null,
      isLoading: false
    }
  },
  methods: {
    uploadFile() {
      this.isLoading = true
      FileService.create(this, this.fileValue)
        .then(r => {
          r.url = this.$HMD.constants.STATIC_ROOT + r.url
          this.fileData = r
          this.$emit("input", r)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    checkFileZize() {
      if (this.fileValue.size > 1024 * 1024 * 2) {
        alert("Selected image is too big (> 2MB)")
        this.fileValue = null
        return false
      }
      return true
    },

    handleChange() {
      if (this.fileValue && this.checkFileZize()) this.uploadFile()
    }
  }
}
</script>

<style lang="scss" scoped></style>
